import { SxProps, Theme } from '@mui/system';

const styles = {
  stackedContainer: {
    marginBottom: '12px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
